import OrganizationInitializer from "./OrganizationInitializer";

export default OrganizationInitializer;